import * as Yup from 'yup';

const advertisePackageSchema = Yup.object().shape({
  labelEn: Yup.string().required('Label En is required.'),
  labelAr: Yup.string().required('Label Ar is required.'),
  code: Yup.string().required('Code is required.'),
  type: Yup.string().required('Type is required.'),
  price: Yup.number()
    .min(0, "Please enter more than 0")
    .typeError("Must be Number").required('Price is required.'),
  // Duration is required for individual, broker, and company types
  duration: Yup.number()
    .when('type', {
      is: 'individual',
      then: (schema) => schema
        .min(1, "Please enter at least 1")
        .typeError("Must be Number")
        .required('Duration is required.'),
      otherwise: (schema) => schema
        .when('type', {
          is: 'company',
          then: (schema) => schema
            .min(1, "Please enter at least 1")
            .typeError("Must be Number")
            .required('Ad Duration is required.'),
          otherwise: (schema) => schema
            .when('type', {
              is: 'broker',
              then: (schema) => schema
                .min(1, "Please enter at least 1")
                .typeError("Must be Number")
                .required('Duration is required.'),
              otherwise: (schema) => schema
                .when('type', {
                  is: 'individual_broker',
                  then: (schema) => schema
                    .min(1, "Please enter at least 1")
                    .typeError("Must be Number")
                    .required('Duration is required.'),
                  otherwise: (schema) => schema.nullable(),
                }),
            }),
        }),
    }),
  // Credit fields are required only for Company (credit-based packages)
  creditCount: Yup.number()
    .when('type', {
      is: 'company',
      then: (schema) => schema
        .min(1, "Please enter at least 1")
        .typeError("Must be Number")
        .required('Credit Count is required.'),
      otherwise: (schema) => schema.nullable(),
    }),
  creditExpirationDays: Yup.number()
    .when('type', {
      is: 'company',
      then: (schema) => schema
        .min(1, "Please enter at least 1")
        .typeError("Must be Number")
        .required('Credit Expiration Days is required.'),
      otherwise: (schema) => schema.nullable(),
    }),
  // Company IDs - if companySelection is 'specific', then at least one company is required
  companyIds: Yup.array()
    .when('companySelection', {
      is: 'specific',
      then: (schema) => schema
        .min(1, 'At least one company must be selected.')
        .required('Company selection is required.'),
      otherwise: (schema) => schema.nullable(),
    }),
  // Broker IDs - if brokerSelection is 'specific', then at least one broker is required
  brokerIds: Yup.array()
    .when('brokerSelection', {
      is: 'specific',
      then: (schema) => schema
        .min(1, 'At least one broker must be selected.')
        .required('Broker selection is required.'),
      otherwise: (schema) => schema.nullable(),
    }),
});

export default advertisePackageSchema;